import { Col, FormGroup, Label, Row } from "reactstrap";
import CommonFileUpload from "../../../../CommonElements/CommonFileUpload";
import { UploadProjectFiles } from "../../../../utils/Constant";

const UploadProjectFile = () => {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label check>{UploadProjectFiles}</Label>
          <CommonFileUpload />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default UploadProjectFile;
